import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  GetMeetingRecordings,
  GetRecordingDetails,
} from "../services/cohortService";
import noAttachment from "../assets/empty-recording.svg";
import recordingicon from "../assets/recording.svg";
import elipsis from "../assets/elipsis.svg";
import SvgClose from "../icons/SvgClose";
import { LoadingOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import logo from "../assets/logo.svg";
import { Modal } from "antd";

const Cohortrecordings = ({ currentCohort }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [recordings, setRecordings] = useState([]);
  const [MuxPlayer, SetMuxPlayer] = useState(null);
  const [openVideo, setOpenVideo] = useState(false);
  const [recordingUrl, setrecordingUrl] = useState("");
  const playerRef = useRef(null);

  const handlePause = () => {
    playerRef.current.pause();
  };

  const getRecordings = async () => {
    setIsLoading(true);
    try {
      const res = await GetMeetingRecordings(
        currentCohort?.meeting_link.split("daily.co/")[1]
      );
      setRecordings(res.data.data);
    } catch (error) {
      console.log(error.response);
    } finally {
      setIsLoading(false);
    }
  };

  const getrecordingUrl = async (id) => {
    try {
      const res = await GetRecordingDetails(id);
      setrecordingUrl(res.data.data.access_link.download_link);
      setOpenVideo(true);
    } catch (error) {}
  };

  useEffect(() => {
    if (currentCohort) {
      getRecordings();
    }
  }, [currentCohort]);

  useEffect(() => {
    import("@mux/mux-player-react").then((MuxPlayer) => {
      SetMuxPlayer(MuxPlayer.default);
    });
  }, []);

  return (
    <>
      <div className="px-4 pb-4 relative">
        <div className="flex flex-col w-full h-[calc(100vh-415px)] overflow-y-auto pt-[10px] pb-[200px] mt-6">
          {isLoading ? (
            <div className="h-full flex justify-center items-center">
              <LoadingOutlined style={{ fontSize: "20px" }} />
            </div>
          ) : !recordings?.length ? (
            <div className="w-full md:w-[400px] mx-auto text-center pt-[40px]">
              <img src={noAttachment} className="mx-auto" alt="" />
              <p className="text-tint">No recordings yet.</p>
            </div>
          ) : (
            <>
              <p className="text-main">Videos</p>
              {recordings?.map((item, index) => (
                <button
                  key={index}
                  className="flex justify-between border-b border-[#ECEBF5] hover:bg-[#EFEFFE] text-left rounded-[10px] p-2 px-3"
                  onClick={() => {
                    getrecordingUrl(item.recording_id);
                  }}
                >
                  <div className="flex items-center gap-2">
                    <div className="bg-[#F9F9FF] w-[44px] h-[44px] rounded-[6px] flex items-center justify-center">
                      <img src={recordingicon} alt="" />
                    </div>
                    <div>
                      <p className="m-0 ctext-main">{`Recording ${
                        index + 1
                      }`}</p>
                      <p className="text-tint text-[12px]">
                        {dayjs(item.created_at).format("DD MMM YYYY hh:mma")}
                      </p>
                    </div>
                  </div>
                  <button className="p-4">
                    <img src={elipsis} alt="" />
                  </button>
                </button>
              ))}
            </>
          )}
        </div>
      </div>

      <Modal
        footer={null}
        title={currentCohort?.title}
        open={openVideo}
        onCancel={() => {
          setOpenVideo(false);
          setrecordingUrl(null);
          handlePause();
        }}
        className="record-modal"
        closeIcon={
          <SvgClose className="h-4 w-4 text-white absolute top-[21px] [@media(max-width:600px)]:right-4" />
        }
      >
        {MuxPlayer && (
          <MuxPlayer
            ref={playerRef}
            streamType="on-demand"
            playbackId={recordingUrl}
            metadataVideoTitle={currentCohort?.title}
            accentColor="#5f5ffa"
            className="w-full h-full relative z-10"
          />
        )}
        <div className="absolute top-[60px] right-[40px] opacity-50 flex justify-end w-fit z-20">
          <img src={logo} alt="" />
        </div>
      </Modal>
    </>
  );
};

export default Cohortrecordings;
